// dependencies
import React from "react";

const Spacer = (props: { height: number }) => {
	const { height } = props;
	return <div style={{ height: height * 8 }} />;
};

export default Spacer;
